<template>
  <div class="part3">
    <img
      class="bg"
      src="../assets/index/part3Bg.png"
      alt=""
      :style="{
        transform: active == 2 ? 'scale(1.1)' : 'scale(1)',
        transition: active == 2 ? 'all 3s' : 'all 1s',
      }"
    />
    <div class="contentWrap" v-if="active == 2">
      <!--        <div class="title1 animate__animated animate__fadeIn">阁韵木窗系统</div>-->
      <div class="title2 animate__animated animate__fadeIn delay1">
        <!-- 精工筑阁 匠心谱韵 -->
        {{ two_title }}
      </div>
      <!--        <div class="title3 animate__animated animate__fadeIn delay2">秉持专注、创新、利他、责任的阁韵精神</div>-->

      <div class="bottomWrap">
        <!-- @mouseover="handleMouse(index)" -->
        <div
          v-for="(item, index) in twolist"
          :key="index"
          class="item animate__animated animate__fadeIn delay1"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img :src="item.image" alt="" />
          </div>
          <div class="title animate__animated animate__fadeIn delay1">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- pc端 -->
      <div
        class="house item animate__animated animate__fadeIn delay4"
        v-if="!isMobile"
      >
        <div class="btn" @click="last">
          <img style="cursor: pointer" src="../assets/index/left.png" alt="" />
        </div>
        <div class="swiperWrap">
          <!-- 左
           -->
          <div class="left" @click="$router.push({ name: 'goods' })">
            <div class="leftIcon"><img :src="icon_image" alt="" /></div>
            <div class="leftName">{{ name }}</div>
          </div>
          <!-- 中 -->
          <div class="middle" @click="$router.push({ name: 'goods' })">
            <img
              class="ng"
              :class="animate ? 'animate__animated animate__fadeIn' : ''"
              :src="bgimage"
              alt=""
            />
            <div class="middleCont">
              <div
                class="middleIcon"
                :class="
                  animate ? 'animate__animated animate__fadeIn delay2' : ''
                "
              >
                <img :src="icon_image" alt="" />
              </div>
              <div
                class="middleName"
                :class="
                  animate ? 'animate__animated animate__fadeIn delay2' : ''
                "
              >
                {{ name }}
              </div>
              <div
                class="line"
                :class="
                  animate ? 'animate__animated animate__fadeInRight delay2' : ''
                "
              ></div>
              <div
                class="desc"
                :class="
                  animate ? 'animate__animated animate__fadeInRight delay2' : ''
                "
              >
                {{ description }}
              </div>
            </div>
          </div>
          <!-- 右 -->
          <div class="right" @click="$router.push({ name: 'goods' })">
            <div class="leftIcon"><img :src="icon_image" alt="" /></div>
            <div class="leftName">{{ name }}</div>
          </div>
        </div>
        <div class="btn" style="cursor: pointer" @click="next">
          <img src="../assets/index/right.png" alt="" />
        </div>
      </div>

      <!-- 移动端 -->
      <div class="house item animate__animated animate__fadeIn delay4" v-else>
        <div class="swiperWrap">
          <div
            v-for="(item, index) in twogoodslistmobile"
            :key="index"
            class="middle"
            @click="$router.push({ name: 'goods' })"
          >
            <img
              class="ng"
              :class="animate ? 'animate__animated animate__fadeIn' : ''"
              :src="item.index_image"
              alt=""
            />
            <div class="middleCont">
              <div
                class="middleIcon"
                :class="
                  animate ? 'animate__animated animate__fadeIn delay2' : ''
                "
              >
                <img :src="item.icon_image" alt="" />
              </div>
              <div
                class="middleName"
                :class="
                  animate ? 'animate__animated animate__fadeIn delay2' : ''
                "
              >
                {{ item.name }}
              </div>
              <div
                class="line"
                :class="
                  animate ? 'animate__animated animate__fadeInRight delay2' : ''
                "
              ></div>
              <div
                class="desc"
                :class="
                  animate ? 'animate__animated animate__fadeInRight delay2' : ''
                "
              >
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { index } from "../api/request";

export default {
  name: "Part2",
  props: {
    index: {
      default: 1,
    },
  },
  data() {
    return {
      isMobile: this.$isMobile,
      animate: true,
      active: "",
      ppbj: require("../assets/index/1.png"),
      gjrz: require("../assets/index/2.png"),
      qgwl: require("../assets/index/3.png"),
      khwx: require("../assets/index/4.png"),

      two_title: "",
      twolist: [],
      twoactive: 0,
      twogoodslist: [],
      arr: [],
      bgimage: null,
      description: "",
      icon_image: null,
      name: "",
      nextid: null,
      previd: null,
      icon_imageleft: null,
      nameleft: null,
      icon_imageright: null,
      nameright: null,
      twogoodslistmobile: [],
    };
  },
  watch: {
    index(val) {
      // console.log(val);
      this.active = val;
    },
  },
  methods: {
    handleMouse(index) {
      this.twoactive = index;
    },
    // 上一张
    last() {
      if (this.animate) {
        return false;
      }
      this.animate = true;
      var left = this.arr.filter((item) => {
        console.log(item);
        return item.id == this.previd;
      });
      left.forEach((item) => {
        this.bgimage = item.index_image;
        this.description = item.description;
        this.icon_image = item.icon_image;
        this.name = item.name;
        this.nextid = item.next_id;
        this.previd = item.pre_id;
      });
    },
    // 下一张
    next() {
      if (this.animate) {
        return false;
      }
      this.animate = true;
      // 点击知道下一张的item
      var right = this.arr.filter((item) => {
        console.log(item);
        return item.id == this.nextid;
      });
      console.log(right);
      right.forEach((item) => {
        this.bgimage = item.index_image;
        this.description = item.description;
        this.icon_image = item.icon_image;
        this.name = item.name;
        this.nextid = item.next_id;
        this.previd = item.pre_id;
      });
    },
  },
  mounted() {
    index().then((res) => {
      if (res.data.code == 1) {
        this.two_title = res.data.data.two_title;
        this.twolist = res.data.data.two;
        // console.log(res.data.data);
        this.twogoodslistmobile = res.data.data.two_goods;
        this.arr = res.data.data.two_goods;
        console.log(this.arr);
        // 默认显示第一张
        this.bgimage = this.arr[0].index_image;
        this.description = this.arr[0].description;
        this.icon_image = this.arr[0].icon_image;
        this.nextid = this.arr[0].next_id;
        this.previd = this.arr[0].pre_id;
        this.icon_image = this.arr[0].icon_image;
        this.name = this.arr[0].name;
      }
    });

    var that = this;
    if (this.animate) {
      setInterval(function () {
        that.animate = false;
      }, 2000);
    }
  },
};
</script>

<style scoped lang="less">
.part3 {
  font-family: 微软雅黑, MicrosoftYaHei;
  color: #ffffff;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .bg {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    object-fit: initial;
    transition: all 3s; /*图片放大过程的时间*/
  }
  .contentWrap {
    position: relative;
    text-align: center;
    .title1 {
      color: #6c7a77;
      margin-top: 80px;
      font-size: 42px;
    }
    .title2 {
      color: #0b4027;
      margin-top: 24px;
      font-size: 60px;
      font-weight: bold;
    }
    .title3 {
      color: #6c7a77;
      margin-top: 24px;
      font-size: 24px;
    }
    .bottomWrap {
      width: 800px;
      margin: 24px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .logo {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          color: #0b4027;
          font-size: 24px;
          margin-top: 30px;
        }
        .desc {
          margin-top: 10px;
          font-size: 18px;
          line-height: 36px;
        }
        .line {
          width: 298px;
          height: 1px;
          background: #ffffff;
          border-radius: 10px;
          margin-top: 43px;
        }
      }
    }
    .house {
      // border: 1px solid blue;
      width: 1380px;
      margin: 62px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn {
        width: 40px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .swiperWrap {
        display: flex;
        align-items: center;
        .left,
        .right {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          width: 177px;
          height: 360px;
          box-shadow: 0px 10px 10px -10px rgba(0, 0, 0, 0.3);
          .leftIcon {
            width: 48px;
            height: 48px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .leftName {
          color: #6c7a77;
          font-size: 24px;
          margin-top: 32px;
        }
        .middle {
          position: relative;
          /*background: #ffffff;*/
          width: 800px;
          height: 400px;
          box-shadow: 0px 10px 10px -10px rgba(0, 0, 0, 0.3);
          .ng {
            z-index: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          .middleCont {
            text-align: left;
            position: relative;
            z-index: 2;
            padding: 20px 0 0 82px;
            .desc {
              width: 544px;
              font-size: 20px;
              font-family: 微软雅黑, MicrosoftYaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 36px;
              margin-top: 28px;
            }
          }
          .middleIcon {
            width: 48px;
            height: 48px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .line {
            width: 34px;
            height: 3px;
            border-radius: 20px;
            background: #ffffff;
            margin-top: 21px;
            transition: width 2s;
          }
          .middleName {
            margin-top: 32px;
            font-size: 32px;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .part3 {
    font-family: 微软雅黑, MicrosoftYaHei;
    color: #ffffff;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    .bg {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      object-fit: initial;
      transition: all 3s; /*图片放大过程的时间*/
    }
    .contentWrap {
      position: relative;
      text-align: center;
      .title1 {
        color: #6c7a77;
        margin-top: 80 * 2px;
        font-size: 42 * 2px;
      }
      .title2 {
        color: #0b4027;
        margin-top: 24 * 2px;
        font-size: 60 * 2px;
        font-weight: bold;
      }
      .title3 {
        color: #6c7a77;
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
      }
      .bottomWrap {
        width: 800px;
        margin: 24 * 2px auto 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          .logo {
            width: 80 * 2px;
            height: 80 * 2px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            color: #0b4027;
            font-size: 24 * 2px;
            margin-top: 30 * 2px;
          }
          .desc {
            margin-top: 38 * 2px;
            font-size: 18 * 2px;
            line-height: 36 * 2px;
          }
          .line {
            width: 298 * 2px;
            height: 1px;
            background: #ffffff;
            border-radius: 10 * 2px;
            margin-top: 43 * 2px;
          }
        }
      }
      .house {
        width: 1580px;
        margin: 62 * 2px auto 0;
        // display: flex;
        align-items: center;
        justify-content: space-between;
        .swiperWrap {
          display: unset;
          .left,
          .right {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            width: 177 * 2px;
            height: 360 * 2px;
            box-shadow: 0px 10 * 2px 10 * 2px -10 * 2px rgba(0, 0, 0, 0.3);
            .leftIcon {
              width: 48 * 2px;
              height: 48 * 2px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .leftName {
            color: #6c7a77;
            font-size: 24 * 2px;
            margin-top: 32 * 2px;
          }
          .middle {
            position: relative;
            /*background: #ffffff;*/
            width: 800 * 2px;
            height: 400 * 2px;
            box-shadow: 0px 10 * 2px 10 * 2px -10px rgba(0, 0, 0, 0.3);
            .ng {
              z-index: 0;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
            .middleCont {
              text-align: left;
              position: relative;
              z-index: 2;
              padding: 5.208vw 0 0 4.271vw;
              .desc {
                width: 544 * 2px;
                font-size: 20 * 2px;
                font-family: 微软雅黑, MicrosoftYaHei;
                font-weight: 400;
                color: #ffffff;
                line-height: 36 * 2px;
                margin-top: 28 * 2px;
              }
            }
            .middleIcon {
              width: 48 * 2px;
              height: 48 * 2px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .line {
              width: 34 * 2px;
              height: 3 * 2px;
              border-radius: 20 * 2px;
              background: #ffffff;
              margin-top: 21 * 2px;
              transition: width 2s;
            }
            .middleName {
              margin-top: 32 * 2px;
              font-size: 32 * 2px;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>